import { app } from "@microsoft/teams-js";
import { ScheduleDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { isSuccess } from "../../_shared/services/ChannelApi";
import { scheduleApi } from "../../_shared/services/ScheduleApi";

export const useSeries = (includeLastSurvey?: boolean) => {
  const [isSeriesLoading, setIsSeriesLoading] = useState<boolean>();
  const [series, setSeries] = useState<ScheduleDTO>();
  const [error, setError] = useState<Error>();

  const loadSeries = useCallback(
    async (context: app.Context, seriesId: string, groupId?: string) => {
      setIsSeriesLoading(true);
      setError(undefined);

      const seriesResponse = await scheduleApi.getSeriesById(
        context,
        seriesId,
        groupId,
        includeLastSurvey
      );
      if (isSuccess(seriesResponse)) {
        setSeries(seriesResponse);
      } else {
        setError(seriesResponse);
      }

      setIsSeriesLoading(false);
    },
    [includeLastSurvey]
  );

  return { error, loadSeries, isSeriesLoading, series, setSeries };
};
